import React from 'react';

interface KpiSkeletonProps {
  count?: number;
  compact?: boolean;
}

const KpiSkeleton: React.FC<KpiSkeletonProps> = ({ count = 6, compact = false }) => {
  return (
    <div className="grid gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className={`
            w-full p-4 rounded-xl border bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700
            ${compact ? 'min-h-[100px]' : 'min-h-[120px]'}
          `}
        >
          <div className="space-y-3">
            {/* Title skeleton */}
            <div className="space-y-2">
              <div className="h-4 bg-slate-200 dark:bg-slate-700 rounded animate-pulse" />
              <div className="flex items-center gap-2">
                <div className="h-3 w-12 bg-slate-200 dark:bg-slate-700 rounded animate-pulse" />
                <div className="h-3 w-8 bg-slate-200 dark:bg-slate-700 rounded animate-pulse" />
              </div>
            </div>

            {/* Value skeleton */}
            <div className="text-center">
              <div className="h-8 bg-slate-200 dark:bg-slate-700 rounded animate-pulse mx-auto w-20" />
            </div>

            {/* Delta skeleton */}
            <div className="flex justify-center">
              <div className="h-6 w-16 bg-slate-200 dark:bg-slate-700 rounded animate-pulse" />
            </div>

            {/* Sparkline skeleton */}
            <div className="space-y-1">
              <div className="h-8 bg-slate-200 dark:bg-slate-700 rounded animate-pulse" />
              <div className="flex justify-between">
                <div className="h-2 w-6 bg-slate-200 dark:bg-slate-700 rounded animate-pulse" />
                <div className="h-2 w-6 bg-slate-200 dark:bg-slate-700 rounded animate-pulse" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default KpiSkeleton;
